// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1VC4u","title":"Header_title__1CbH7","left":"Header_left__1Rc8t","clinicName":"Header_clinicName__3_6R5"};